import { holdsControls, type Column } from './table-types.ts';
import styles from './DataTable.module.css';

export const RowCard = <Row,>({
  row,
  columns,
  highlighted,
  onSelect,
}: {
  row: Row;
  columns: readonly Column<Row>[];
  highlighted: boolean;
  onSelect: (() => void) | undefined;
}) => {
  const primary = columns.find((column) => column.primary);
  const status = columns.find((column) => column.status);
  const details = columns.filter(
    (column) => column !== primary && column !== status && !holdsControls(column),
  );
  return (
    <button
      type="button"
      className={[styles['card'], highlighted ? styles['highlightedCard'] : ''].join(' ')}
      aria-current={highlighted ? 'true' : undefined}
      onClick={onSelect}
      disabled={onSelect === undefined}
    >
      {primary === undefined && status === undefined ? null : (
        <span className={styles['cardHead']}>
          <span>{primary?.cell(row)}</span>
          {status?.cell(row)}
        </span>
      )}
      {details.map((column) => (
        <span key={column.id} className={styles['cardRow']}>
          <span className={styles['cardLabel']}>{column.header}</span>
          <span>{column.cell(row)}</span>
        </span>
      ))}
    </button>
  );
};
